<template>
    <div>
        <h2 :style="{'color': '#4fa2b7'}">Building Structure</h2>
        <div class="d-flex align-center mt-2">
            <div class="mr-3">
                <h4>Ground Floors</h4>
                <div class="counterItem">
                    <button class="decreaseBtn" @click="deleteGroundFloor">-</button>
                    <p class="">{{groundFloors}}</p>
                    <button class="increaseBtn" @click="addGroundFloor">+</button>
                </div>
            </div>
            <div class="mr-3">
                <h4>Underground Floors</h4>
                <div class="counterItem">
                    <button class="decreaseBtn" @click="deleteUndergroundFloor">-</button>
                    <p class="">{{undergroundFloors}}</p>
                    <button class="increaseBtn" @click="addUndergroundFloor">+</button>
                </div>
            </div>
            <div class="mr-3">
                <h4>Columns</h4>
                <div class="counterItem">
                    <button class="decreaseBtn" @click="deleteColumn">-</button>
                    <p class="">{{columns}}</p>
                    <button class="increaseBtn" @click="$emit('add-column')">+</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    name: "VerticalStructureButtons",
    props:{
        columns:{
            type: Number
        },
        undergroundFloors:{
            type: Number
        },
        groundFloors:{
            type: Number
        }
    },
    methods: {
        deleteColumn(){
            if(this.columns > 0){
                this.$emit('delete-column', this.columns);
            }
        },
        addUndergroundFloor(){
            this.$emit('add-underground-floor', -1 - this.undergroundFloors, 'underground');
        },
        deleteUndergroundFloor(){
            if(this.undergroundFloors > 0){
                this.$emit('delete-floor',-this.undergroundFloors);
            }
        },
        addGroundFloor(){
            this.$emit('add-ground-floor', this.groundFloors, 'ground');
        },
        deleteGroundFloor(){
            if(this.groundFloors > 1){
                this.$emit('delete-floor', this.groundFloors-1);
            }
        }
    }

}

</script>
<style>
.counterItem{
    width: 90px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    padding: 3px;
    margin-top: 3px;
}
.counterItem > p{
    margin: 0 !important;
}
.decreaseBtn, .increaseBtn{
    font-weight: bold;
    font-size: 14px;
    width: 20px;
    height: 100%;
    background-color: rgb(228, 220, 210);
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/VerticalStructureButtons.vue